<template>
  <section class="variation-list">
    <div class="container-fluid border-top">
      <div class="row">
        <div class="col-12">
          <br />
        </div>
      </div>
    </div>
    <div
      class="container-fluid"
      v-if="
        currentItem.description.stones.diamondStock != false &&
        currentItem.description.stones.diamondStock.certificate != ''
      "
    >
      <div class="row">
        <div class="col-12 text-center">
          <div
            @click="configure('stones')"
            class="panel panel-default selected-stone"
          >
            <div class="panel-heading stone-headline">
              {{ $t("Menu.list.diamondStock.selectedStone.title") }}
            </div>
            <div class="panel-body stone-body">
              {{ currentItem.description.stones.diamondStock.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid" v-if="possibleItems.form">
      <div class="row form-horizontal">
        <div class="col-12 col-sm-6 col-md-12 input-group">
          <label class="col-4 control-label">{{
            $t("Menu.list.diamondStock.form.stoneType")
          }}</label>
          <div class="col-8">
            <select
              v-model="search.stoneType"
              @change="searchDiamonds"
              class="form-control select-stonetype"
              :class="{ 'lab-grown': parseInt(search.stoneType) === 5 }"
              ref="selectStoneType"
            >
              <option value="1">
                {{ $t("Menu.list.diamondStock.stoneType.natural") }}
              </option>
              <option value="5" v-if="currentItem.description.brandId !== 3">
                {{ $t("Menu.list.diamondStock.stoneType.labGrown") }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-12 input-group">
          <label class="col-4 control-label">{{
            $t("Menu.list.diamondStock.form.carat")
          }}</label>
          <div class="col-8">
            <select
              v-model="search.carat"
              @change="searchDiamonds"
              class="form-control"
            >
              <option
                v-for="(item, index) in possibleItems.form.carat_select"
                v-bind:key="index"
                v-bind:value="index"
              >
                {{ item }} ct.
              </option>
            </select>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-12 input-group">
          <label class="col-4 control-label"
            >{{ $t("Menu.list.diamondStock.form.form") }}:</label
          >
          <div class="col-8">
            <select
              v-model="search.form"
              @change="searchDiamonds"
              class="form-control"
              ref="selectStoneform"
            >
              <template
                v-for="(item, index) in possibleItems.form.stoneform_select"
              >
                <option
                  v-if="
                    ((currentItem.description.brandId === 2 ||
                      currentItem.description.brandId === 12 ||
                      currentItem.description.brandId === 24) &&
                      index !== 'F') ||
                    (currentItem.description.brandId !== 2 &&
                      currentItem.description.brandId !== 12 &&
                      currentItem.description.brandId !== 24 &&
                      parseInt(search.stoneType) !== 5 &&
                      index !== 'Q') ||
                    (parseInt(search.stoneType) === 5 && index !== 'F')
                  "
                  v-bind:key="index"
                  v-bind:value="index"
                >
                  {{ item }}
                </option>
              </template>
            </select>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-12 input-group">
          <label class="col-4 control-label">{{
            $t("Menu.list.diamondStock.form.color")
          }}</label>
          <div class="col-8">
            <select
              v-model="search.color"
              @change="searchDiamonds"
              class="form-control"
            >
              <option
                v-for="(item, index) in possibleItems.form.color_select"
                v-bind:key="index"
                v-bind:value="index"
              >
                {{ item }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-12 input-group">
          <label class="col-4 control-label">{{
            $t("Menu.list.diamondStock.form.purity")
          }}</label>
          <div class="col-8">
            <select
              v-model="search.purity"
              @change="searchDiamonds"
              class="form-control"
            >
              <option
                v-for="(item, index) in possibleItems.form.purity_select"
                v-bind:key="index"
                v-bind:value="index"
              >
                {{ item }}
              </option>
            </select>
          </div>
        </div>
        <div
          class="col-12 col-sm-6 col-md-12 input-group"
          :class="{ hidden: search.form && search.form[0] !== 'A' }"
        >
          <label class="col-4 control-label">{{
            $t("Menu.list.diamondStock.form.finish")
          }}</label>
          <div class="col-8">
            <select
              v-model="search.finish"
              @change="searchDiamonds"
              class="form-control"
            >
              <option
                v-for="(item, index) in possibleItems.form.finish_select"
                v-bind:key="index"
                v-bind:value="index"
              >
                {{ item }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-12 input-group">
          <label class="col-4 control-label">{{
            $t("Menu.list.diamondStock.form.polish")
          }}</label>
          <div class="col-8">
            <select
              v-model="search.polish"
              @change="searchDiamonds"
              class="form-control"
            >
              <option
                v-for="(item, index) in possibleItems.form.polish_select"
                v-bind:key="index"
                v-bind:value="index"
              >
                {{ item }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-12 input-group">
          <label class="col-4 control-label">{{
            $t("Menu.list.diamondStock.form.symmetry")
          }}</label>
          <div class="col-8">
            <select
              v-model="search.symmetry"
              @change="searchDiamonds"
              class="form-control"
            >
              <option
                v-for="(item, index) in possibleItems.form.symmetry_select"
                v-bind:key="index"
                v-bind:value="index"
              >
                {{ item }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-12 input-group">
          <label class="col-4 control-label">{{
            $t("Menu.list.diamondStock.form.fluorescence")
          }}</label>
          <div class="col-8">
            <select
              v-model="search.fluorescence"
              @change="searchDiamonds"
              class="form-control"
            >
              <option
                v-for="(item, index) in possibleItems.form.fluorescence_select"
                v-bind:key="index"
                v-bind:value="index"
              >
                {{ item }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-12 input-group certificate-form">
          <label class="col-4 control-label">{{
            $t("Menu.list.diamondStock.form.certificate")
          }}</label>
          <div class="col-8 checkbox">
            <label class="checkbox-inline">
              <input
                type="checkbox"
                value="1"
                name="gia"
                v-model="search.certificate"
                @change="searchDiamonds"
                :class="{ 'input-lab-grown': parseInt(search.stoneType) === 5 }"
              />
              <span>GIA</span>
            </label>
            <label class="checkbox-inline">
              <input
                type="checkbox"
                value="2"
                name="igi"
                v-model="search.certificate"
                @change="searchDiamonds"
                :class="{ 'input-lab-grown': parseInt(search.stoneType) === 5 }"
              />
              <span>IGI</span>
            </label>
            <label class="checkbox-inline">
              <input
                type="checkbox"
                value="3"
                name="hrd"
                v-model="search.certificate"
                @change="searchDiamonds"
                :class="{ 'input-lab-grown': parseInt(search.stoneType) === 5 }"
              />
              <span>HRD</span>
            </label>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-12 input-group">
          <label class="col-4 control-label">{{
            $t("Menu.list.diamondStock.form.certificateNo")
          }}</label>
          <div class="col-8">
            <input
              type="text"
              v-model="search.certificateNo"
              @change="searchDiamonds"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-12 input-group show-fav">
          <label class="col-4 control-label">{{
            $t("Menu.list.diamondStock.form.stoneIds")
          }}</label>
          <div class="col-8">
            <input
              type="checkbox"
              value="1"
              name="showWishlist"
              v-model="search.showWishlist"
              @change="searchDiamonds"
              :class="{ 'input-wl-lab-grown': parseInt(search.stoneType) === 5 }"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid" v-if="possibleItems.diamonds_found > 0">
      <div class="row">
        <div class="col-12 text-start">
          <ul class="diamond-nav">
            <li v-if="navSite > 1" @click="changeSite(navSite - 1)">
              &lt;&lt;
            </li>
            <li
              v-for="(site, index) in siteList.sites"
              @click="changeSite(site)"
              v-bind:key="index"
              :class="{
                curSite: site == navSite,
                'lab-grown': siteList.stoneType == 5,
              }"
            >
              {{ site }}
            </li>
            <li v-if="navSite < maxSites" @click="changeSite(navSite + 1)">
              &gt;&gt;
            </li>
          </ul>
        </div>
      </div>
      <div id="diamondItemList">
        <div
          class="row diamond-item"
          v-for="(item, index) in possibleItems.list"
          v-bind:key="index"
        >
          <div class="col-4 diamond-col">
            <p class="carat" :class="{ 'lab-grown': item.stone_type === '5' }">
              {{ item.certificate }} {{ item.stone_size }} ct.<br />
              <img
                :ref="index"
                @error="setImageNotAvailable($refs[index])"
                :src="
                  appUrl +
                  '/img/assets/stones/exchange/' +
                  item.picture +
                  '_small.jpg'
                "
                :srcset="
                  appUrl +
                  '/img/assets/stones/exchange/' +
                  item.picture +
                  '_small@2x.jpg'
                "
                class="img-responsive"
              />
            </p>
          </div>
          <div class="col-4 diamond-col">
            <p class="price" :class="{ 'lab-grown': item.stone_type === '5' }">
              {{ $n(item.cachePrice, "currency") }}
              <span
                :ref="'wishlist-' + index"
                class="wishlist-toggle-icon"
                @click="toggleWishlist(index)"
              >
                <template v-if="isOnWishlist[index] === true">&#9829;</template>
                <template v-else>&#9825;</template>
              </span>
            </p>
            <p>
              {{ item.color }}<br />
              {{ $t("Menu.list.diamondStock.table.purity") }}:
              {{ item.purity.substring(0, item.purity.indexOf("-") - 1) }}<br />
              <span :class="{ hidden: search.form && search.form[0] !== 'A' }"
                >{{ $t("Menu.list.diamondStock.table.finish") }}:
                {{ item.finish }}</span
              >
            </p>
          </div>
          <div class="col-4 diamond-col">
            <a
              class="btn btn-sm btn-block btn-details"
              @click="
                showDetails !== index
                  ? (showDetails = index)
                  : (showDetails = '')
              "
            >
              {{ $t("Menu.list.diamondStock.buttonMore") }}
            </a>
            <a
              v-if="getJewelleryType !== 1"
              class="btn btn-sm btn-block btn-add"
              :class="{
                'btn-active': showDetails === index,
                'lab-grown': item.stone_type === '5',
              }"
              @click="addDiamondToItem(item.pool_id)"
            >
              {{ $t("Menu.list.diamondStock.button") }}
            </a>
          </div>
          <div
            class="col-12 diamond-details"
            :class="{ hidden: showDetails !== index }"
          >
            {{ item.purity }}<br />
            {{ $t("Menu.list.diamondStock.table.polish") }}:
            {{ item.polish }}&nbsp;|&nbsp;
            {{ $t("Menu.list.diamondStock.table.symmetry") }}: {{ item.symmetry
            }}<br />
            {{ $t("Menu.list.diamondStock.table.fluorescence") }}:
            {{ item.fluorescence }}
            <span v-if="item.abstract_stone === 'no'"
              >&nbsp;|&nbsp;{{ item.width }} x {{ item.length }} x
              {{ item.height }} mm</span
            >
            <span class="lab-grown" v-if="item.stone_type === '5'">
              <br />{{ $t("Menu.list.diamondStock.stoneType.labGrown") }}
            </span>
            <template v-if="item.certificateNr && item.certificate_id === '1'">
              <br />
              <a
                :href="
                  'https://www.gia.edu/report-check?reportno=' +
                  item.certificateNr
                "
                :class="{ 'lab-grown': item.stone_type === '5' }"
                target="_blank"
              >
                {{ item.certificate }} {{ item.certificateNr }}
              </a>
              <span v-if="isShopLoginActive" class="small"
                >({{ item.supplier }})</span
              >
            </template>
            <template
              v-else-if="item.certificateNr && item.certificate_id === '2'"
            >
              <br />
              <a
                :href="
                  'https://www.igi.org/verify-your-report/?r=' +
                  item.certificateNr
                "
                :class="{ 'lab-grown': item.stone_type === '5' }"
                target="_blank"
              >
                {{ item.certificate }} {{ item.certificateNr }}
              </a>
              <span v-if="isShopLoginActive" class="small"
                >({{ item.supplier }})</span
              >
            </template>
            <template
              v-else-if="item.certificateNr && item.certificate_id === '3'"
            >
              <br />
              <a
                :href="
                  'https://my.hrdantwerp.com/?record_number=' +
                  item.certificateNr
                "
                :class="{ 'lab-grown': item.stone_type === '5' }"
                target="_blank"
              >
                {{ item.certificate }} {{ item.certificateNr }}
              </a>
              <span v-if="isShopLoginActive" class="small"
                >({{ item.supplier }})</span
              >
            </template>
            <template v-else-if="isShopLoginActive">
              <br />
              <span class="small">({{ item.supplier }})</span>
            </template>
            <a
              v-if="isShopLoginActive"
              class="btn btn-sm btn-block btn-diamond-as-item"
              :class="{ 'lab-grown': item.stone_type === '5' }"
              @click="addDiamondAsArticle(item.pool_id)"
            >
              {{ $t("Menu.list.diamondStock.buttonAddAsItem") }}
            </a>
            <img
              :src="appUrl + '/img/icons/close.svg'"
              class="close-diamond-details"
              @click="showDetails = ''"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-start">
          <ul class="diamond-nav" ref="diamondNav">
            <li v-if="navSite > 1" @click="changeSite(navSite - 1)">
              &lt;&lt;
            </li>
            <li
              v-for="(site, index) in siteList.sites"
              @click="changeSite(site)"
              v-bind:key="index"
              :class="{
                curSite: site == navSite,
                'lab-grown': siteList.stoneType == 5,
              }"
            >
              {{ site }}
            </li>
            <li v-if="navSite < maxSites" @click="changeSite(navSite + 1)">
              &gt;&gt;
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container-fluid" v-else>
      <div class="row">
        <div class="col-12 text-center col-empty">
          {{ $t("Menu.list.diamondStock.empty") }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SetData from "@/vuex/SetData";
import DAODiamondExchange from "@/assets/DAO/DiamondExchange";
import Status from "@/vuex/Status";
import Config from "@/vuex/Config";
import Logger from "@/assets/Helper/Logger";
import Notification from "@/assets/Helper/Notification";
import Wishlist from "@/assets/Wishlist";
import DAOWishlist from "../../../public/js/DAO/Wishlist";

export default {
  name: "DiamondExchange",
  props: ["possibleItems", "groupId", "stoneId"],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      search: {
        carat: [],
        color: [],
        form: [],
        finish: [],
        purity: [],
        polish: [],
        symmetry: [],
        fluorescence: [],
        certificateNo: "",
        certificate: [],
        showWishlist: false,
        stoneIds: [],
        stoneType: 1,
      },
      navLimit: 10,
      navSite: 1,
      navPlaceholder: "...",
      currentItem: SetData.getters.getCurrentItem,
      showDetails: "",
      isOnWishlist: {},
    };
  },
  watch: {
    "possibleItems.form": {
      handler: function () {
        if (
          this.possibleItems.form &&
          typeof this.possibleItems.form.stoneform_select === "object"
        ) {
          this.possibleItems.form.stoneform_select.Q = "Marquise";

          let tmpStoneformList = Object.entries(
            this.possibleItems.form.stoneform_select
          ).sort((a, b) => {
            if (b[1] < a[1]) {
              return 1;
            } else if (b[1] > a[1]) {
              return -1;
            } else {
              if (a[0] < b[0]) {
                return 1;
              } else if (a[0] > b[0]) {
                return -1;
              } else {
                return 0;
              }
            }
          });

          if (tmpStoneformList.length > 0) {
            this.possibleItems.form.stoneform_select = {};
            tmpStoneformList.forEach((item) => {
              this.possibleItems.form.stoneform_select[item[0]] = item[1];
            });
          }
        }
      },
    },
    "possibleItems.search": {
      handler: function () {
        if (
          this.possibleItems.search &&
          typeof this.possibleItems.search.carat_select === "object"
        ) {
          this.search.carat = this.possibleItems.search.carat_select.from;
          this.search.color = this.possibleItems.search.color_select.from;
          this.search.form = this.possibleItems.search.stoneform_select.from;
          this.search.finish = this.possibleItems.search.finish_select.from;
          this.search.purity = this.possibleItems.search.purity_select.from;
          this.search.polish = this.possibleItems.search.polish_select.from;
          this.search.symmetry = this.possibleItems.search.symmetry_select.from;
          this.search.fluorescence =
            this.possibleItems.search.fluorescence_select.from;
          this.search.certificateNo = this.possibleItems.search.certificate.nr;
          this.search.certificate =
            this.possibleItems.search.certificate_select.split("-");
          this.search.stoneIds = this.possibleItems.search.stoneIds;

          if (parseInt(this.possibleItems.search.stoneType) > 0) {
            this.search.stoneType = this.possibleItems.search.stoneType;
          }

          if (
            this.$refs["selectStoneform"] &&
            !this.$refs["selectStoneform"].value
          ) {
            if (this.search.form === "Q") {
              this.search.form = "F";
              this.searchDiamonds(true);
            } else if (this.search.form === "F") {
              this.search.form = "Q";
              this.searchDiamonds(true);
            }
          }

          SetData.dispatch("setDiamondExchangeSearch", this.search);
          if (
            typeof this.search.stoneIds == "object" &&
            this.search.stoneIds.length > 0
          ) {
            this.search.showWishlist = "1";
          }
        }
      },
      deep: true,
    },
    "possibleItems.list": {
      handler: function () {
        if (
          this.possibleItems.list &&
          typeof this.possibleItems.list == "object"
        ) {
          for (let id in this.possibleItems.list) {
            this.isDiamondInWishlist(id);
          }
        }
        setTimeout(() => {
          this.$forceUpdate();
        }, 500);
      },
      deep: true,
    },
  },
  methods: {
    changeSite: function (newSite) {
      if (newSite != this.navPlaceholder) {
        this.showDetails = "";

        if (newSite < 0) {
          this.newSite = 0;
        } else {
          let maxSite = this.maxSites;
          this.navSite = maxSite < newSite ? maxSite : newSite;
        }

        this.searchDiamonds(false);
      }
    },
    searchDiamonds: function (setFirstSite) {
      if (setFirstSite !== false) {
        this.navSite = 1;
      }
      Status.dispatch("setLoading", true);

      let certificate = this.search.certificate.join("-");
      certificate = certificate.replace("false-", "");
      certificate = certificate.replace("-false", "");

      if (this.search.showWishlist == "1") {
        let stoneIds = [];
        DAOWishlist.getAll("diamonds").then((result) => {
          if (typeof result === "object" && result.length > 0) {
            for (let numericKey in result) {
              stoneIds[numericKey] = result[numericKey].id.replace("id_", "");
            }
          }
          this.getList(certificate, stoneIds);
        });
      } else {
        this.getList(certificate, false);
      }
    },
    getList: function (certificate, stoneIds) {
      this.$refs["selectStoneType"].classList.remove("lab-grown");
      if (this.search.stoneType === "5") {
        this.$refs["selectStoneType"].classList.add("lab-grown");
      }

      if (
        this.possibleItems.search.stoneType !== this.search.stoneType &&
        this.search.stoneType === "5"
      ) {
        this.search.color = "9_id";
        this.search.finish = "3_id";
        this.search.purity = "3_id";
        this.search.polish = "3_id";
        this.search.symmetry = "3_id";
      }

      // Cut only for brilliants!
      if (this.search.form !== "A") {
        this.search.finish = "5_id";
      }

      DAODiamondExchange.getList(
        Config.getters.getCountry,
        this.search.carat,
        this.search.color,
        this.search.finish,
        this.search.polish,
        this.search.purity,
        this.search.form,
        this.search.symmetry,
        this.search.fluorescence,
        this.search.certificateNo,
        certificate,
        stoneIds,
        this.search.stoneType,
        this.navSite,
        this.navLimit
      ).then((response) => {
        this.$set(this.possibleItems, "list", response.list);
        this.$set(this.possibleItems, "search", response.search);
        this.$set(
          this.possibleItems,
          "diamonds_found",
          response.diamonds_found
        );
        Status.dispatch("setLoading", false);
      });
    },
    isDiamondAlreadySet: function (diamondId) {
      let set = SetData.getters.getSet;
      for (let i in set.items) {
        if (
          set.items[i].description &&
          set.items[i].description.stones &&
          set.items[i].description.stones.diamondStock &&
          set.items[i].description.stones.diamondStock.isReal === true &&
          set.items[i].description.stones.diamondStock.poolId == diamondId
        ) {
          return true;
        }
      }
      return false;
    },
    addDiamondToItem: function (diamondId) {
      Status.dispatch("setLoading", true);
      let item = SetData.getters.getCurrentItem;
      let isDiamondAlreadySet = this.isDiamondAlreadySet(diamondId);

      if (typeof item == "object" && isDiamondAlreadySet === false) {
        let groupId = this.$parent.$parent.getGroupForDiamondExchange();
        DAODiamondExchange.addToItem(
          item.itemnumber,
          diamondId,
          groupId,
          this.stoneId
        ).then(
          (newItemnumber, alerts) => {
            if (typeof newItemnumber == "string") {
              if (
                SetData.getters.getCurrentItem.description.jewelleryType > 0
              ) {
                this.$parent.$data.currentVarType = "stones/jewellery/normal";
              } else {
                this.$parent.$data.currentVarType =
                  "stones/group/" + groupId + "/" + this.stoneId;
              }
              this.$parent.changeItem(newItemnumber, alerts);
            }
            Status.dispatch("setLoading", false);
          },
          (alerts) => {
            if (typeof alerts == "object" && alerts.length > 0) {
              Logger.debug("Alerts", alerts);

              for (let key in alerts) {
                Notification.create(alerts[key].title, alerts[key].text);
              }
            } else {
              Logger.debug("No alerts set", alerts);
            }
            Status.dispatch("setLoading", false);
          }
        );
      } else {
        Status.dispatch("setLoading", false);

        if (isDiamondAlreadySet === true) {
          Notification.create(
            "",
            this.$t("Notifications.diamondExchange.isAlreadySet")
          );
        }
      }
    },
    addDiamondAsArticle: function (diamondId) {
      if (this.isDiamondAlreadySet(diamondId) === false) {
        Status.dispatch("setLoading", true);

        DAODiamondExchange.getItemnumber(diamondId).then(
          (itemnumber) => {
            if (typeof itemnumber == "string") {
              SetData.dispatch("addItem", itemnumber);

              Config.dispatch("setVisualMode", "show");

              this.$parent.$parent.$parent["setCurrentItem"]("overview");
              this.$root.$emit("setOverview");
            }
            Status.dispatch("setLoading", false);
          },
          (alerts) => {
            if (typeof alerts == "object" && alerts.length > 0) {
              Logger.debug("Alerts", alerts);

              for (let key in alerts) {
                Notification.create(alerts[key].title, alerts[key].text);
              }
            } else {
              Logger.debug("No alerts set", alerts);
            }

            Status.dispatch("setLoading", false);
          }
        );
      } else {
        Notification.create(
          "",
          this.$t("Notifications.diamondExchange.isAlreadySet")
        );
      }
    },
    isDiamondInWishlist: function (id) {
      DAOWishlist.getDiamond(id).then((result) => {
        this.isOnWishlist[id] = result !== false;
      });
    },
    toggleWishlist: function (id) {
      if (this.$refs["wishlist-" + id]) {
        Wishlist.toggleDiamond(id).then((result) => {
          if (result == true) {
            this.$refs["wishlist-" + id][0].innerHTML = "&#9829;";
          } else {
            this.$refs["wishlist-" + id][0].innerHTML = "&#9825;";
          }
        });
      }
    },
    configure: function (type) {
      this.$root.$emit("configure", type);
    },
    setImageNotAvailable: function (diamondImageNode) {
      if (diamondImageNode && diamondImageNode[0]) {
        diamondImageNode[0].src = this.appUrl + "/img/icons/help_dark.svg";
        diamondImageNode[0].srcset = this.appUrl + "/img/icons/help_dark.svg";
      }
    },
  },
  computed: {
    getJewelleryType: function () {
      return this.$parent.$parent["getJewelleryType"]();
    },
    isShopLoginActive: function () {
      return Config.getters.isShopLoginActive;
    },
    maxSites() {
      if (typeof this.possibleItems == "undefined") {
        return Math.ceil(this.possibleItems.diamonds_found / this.navLimit);
      } else {
        return Math.ceil(this.possibleItems.diamonds_found / this.navLimit);
      }
    },
    siteList() {
      let siteList = { sites: [], stoneType: this.search.stoneType };
      let maxSite = this.maxSites;
      let egdeSites = 1;
      let middleSites = 2;

      for (let i = 1; i <= maxSite; i++) {
        if (
          i <= egdeSites ||
          i > maxSite - egdeSites ||
          (i >= this.navSite - middleSites && i <= this.navSite + middleSites)
        ) {
          siteList.sites.push(i);
        }
      }

      for (let i in siteList.sites) {
        i = parseInt(i);
        if (typeof siteList.sites[i + 1] != "undefined") {
          if (
            siteList.sites[i] + 1 !== siteList.sites[i + 1] &&
            siteList.sites[i] !== this.navPlaceholder
          ) {
            siteList.sites.splice(i + 1, 0, this.navPlaceholder);
          }
        }
      }

      return siteList;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.container-fluid.border-top {
  background-color: #ffffff;
}

.input-group {
  margin-bottom: 1rem;
}

select {
  height: 4rem;
}

.diamond-nav {
  list-style: none;
  padding: 1rem 0;
  margin: 3rem 0;
}

.diamond-nav li {
  list-style: none none;
  display: inline-block;
  margin-right: 0.1em;
  padding: 0em;
  cursor: pointer;
  background-color: $lightGreyBg;
  line-height: 2em;
  width: 2em;
  text-align: center;
}

.diamond-nav li.curSite {
  font-weight: bold;
  background-color: $gray;
  color: #fff;

  &.lab-grown {
    background-color: $green-lab;
  }
}

.control-label {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0rem;
  text-align: left;
  margin-bottom: 0rem;
}

.certificate-form {
  line-height: 4rem;
  margin-bottom: 2rem;
}


.certificate-form .checkbox-inline {
  padding-top: 0rem;
  margin-top: -0.25rem;
  margin-right: 1.5rem;

  input[type="checkbox"] {
    &:checked {
      accent-color: $gray;

      &.input-lab-grown {
        accent-color: $green-lab;
      }
    }
  }
}

.certificate-form .checkbox-inline span {
  display: inline-block;
  margin-top: 0.2rem;
  margin-left: 0.5rem;
}

.show-fav {
  height: 4rem;

  input[type="checkbox"] {
    &:checked {
      accent-color: $gray;

      &.input-wl-lab-grown {
        accent-color: $green-lab;
      }
    }
  }
}

.col-empty {
  margin-top: 4rem;
}

#diamondItemList {
  .row {
    border-bottom: 1px solid $borderColor;

    &.diamond-item {
      padding: 0.5rem 0;

      .diamond-details {
        margin: 1rem 0;

        span.lab-grown {
          color: $green-lab;
          font-weight: bold;
        }

        a {
          color: $gray;
          font-weight: bold;

          &.lab-grown {
            color: $green-lab;
          }
        }

        .close-diamond-details {
          position: absolute;
          cursor: pointer;
          right: 1.5rem;
          top: 0rem;
        }

        .btn-diamond-as-item {
          margin-top: 1rem;
          color: white;
          font-weight: bold;
          background-color: $gray;
          border-color: $gray;

          &.lab-grown {
            color: white;
            font-weight: bold;
            background-color: $green-lab;
            border-color: $green-lab;
          }
        }
      }
    }

    p {
      margin: 0.5rem 0;
    }

    .diamond-col {
      .price,
      .carat {
        font-weight: bold;
        color: $gray;

        &.lab-grown {
          color: $green-lab;
        }
      }
    }

    .diamond-col:nth-child(2) {
      padding: 0;
    }

    .diamond-col .carat img {
      display: inline;
      text-align: center;
      max-width: 5rem;
      margin-top: 1rem;
    }

    .diamond-col .btn-add {
      margin-top: 1rem;
      color: #fff;
      font-weight: bold;
      background-color: $gray;
      border-color: $gray;
    }

    .btn-add.lab-grown,
    .btn-diamond-as-item.lab-grown {
      color: #fff;
      font-weight: bold;
      background-color: $green-lab;
      border-color: $green-lab;
    }

    .diamond-col .btn-active {
      //background-color: $pink;
      //border-color: $pink;
      //color: white;
      //font-weight: bold;
    }

    &:last-child {
      border-bottom: none;
    }

    .wishlist-toggle-icon {
      display: inline-block;
      padding: 0 1rem;
      cursor: pointer;
    }
  }
}

.form-horizontal .input-group {
  margin-left: 0;
  margin-right: 0;
}

.form-horizontal .checkbox {
  padding-top: 0rem;
}

select.select-stonetype {
  color: #fff;
  font-weight: bold;
  background-color: $gray;
  border-color: $gray;

  &.lab-grown {
    color: #fff;
    font-weight: bold;
    background-color: $green-lab;
    border-color: $green-lab;
  }
}

.selected-stone {
  cursor: pointer;
  margin: 0 0 2.5rem .75rem;
  text-align: left;
  background-color: #ffffff;

  .stone-headline {
    font-weight: bold;
  }

  @media (min-width: 992px) {
    width: 26.5rem;
  }

  @media (min-width: 1200px) {
    width: 32.5rem;
  }
}
</style>
